<template>
    <div class="big-box">
        <div style="width:100%;height:140rem;position: relative;display:flex;">
            <div style="width:20%;height:100%;padding-left:100rem;display:flex;justify-content: flex-start;align-content: center;align-items: center;left: -60rem;">
                <span style="font-size: 30rem;">{{curTime}}</span>
            </div>
            <div class="nowrap" style="width:60%;height:100%;font-size:85rem;text-align: center;">
                {{proInfo.name}}智慧工地数据展示平台
            </div>
            <div style="width:20%;height:100%;"></div>
        </div>
        <div class="list-group-box1">
            <draggable class="list-group" tag="ul" :list="list0" group="project" @change="log">
                <li class="list-group-item" v-for="(element, index) in list0" :key="index" :index="element.index">
                    <div v-if="element.index=='1' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 人员动态 </p>
                        <div style="width:100%;position: relative;" :style="{'height':element.height+'rem'}">
                            <div style="width:100%;height:11%;position: relative;display:flex;padding:0 0 0 36rem;align-items: center;">
                                <p style="font-size:28rem;color:#fff;padding-left:10rem;">累计采集{{syn.zs}}人</p>
                                <p style="font-size:28rem;color:#fff;padding-left:30rem;">实名占比{{syn.smRate}}</p>
                            </div>
                            <div style="width:100%;height:89%;position: relative;display:flex;">
                                <div style="width: 40%;height: 100%;">
                                    <div id="myChart1" style="width:100%; height:100%;"></div>
                                </div>
                                <div style="width: 60%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                    <div style="width:100%;padding-left:20rem;display:flex;align-items: center;">
                                        <p style="width: 50%;position: relative;height: 20rem;top: -10rem;"><el-progress :text-inside="true" :percentage="parseFloat(syn.zzLv)" :stroke-width="20"></el-progress></p>
                                        <p style="color:#fff;display:flex;padding-left:20rem;">在职人员({{syn.zz}}/{{syn.zs}})</p>
                                    </div>
                                    <div style="width:100%;padding-left:20rem;display:flex;align-items: center;">
                                        <p style="width: 50%;position: relative;height: 20rem;top: -10rem;"><el-progress :text-inside="true" :percentage="parseFloat(syn.lzLv)" :stroke-width="20" color="#FF9F20"></el-progress></p>
                                        <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">离职人员({{syn.lz}}/{{syn.zs}})</p>
                                    </div>
                                    <div style="width:100%;padding-left:20rem;display:flex;align-items: center;">
                                        <p style="width: 50%;position: relative;height: 20rem;top: -10rem;"><el-progress :text-inside="true" :percentage="parseFloat(syn.wzzLv)" :stroke-width="20" color="#64EBA8"></el-progress></p>
                                        <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未分配人员({{syn.wzz}}/{{syn.zs}})</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='2' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 安全教育 </p>
                        <div style="width:100%;position: relative;display:flex;" :style="{'height':element.height+'rem'}">
                            <div style="width:50%;height:100%;position: relative;">
                                <div id="eduChart" style="width:100%; height:100%;"></div>
                                <p style="position: absolute;right:80rem;bottom: 20rem;">受教育人数   <span style="color:#67C23A;;">{{parseInt(exam.educationNum)}}</span>人</p>
                            </div>
                            <div style="width:50%;height:100%;position: relative;">
                                <div id="examChart" style="width:100%; height:100%;"></div>
                                <p style="position: absolute;right:80rem;bottom: 20rem;">入职考试人数   <span style="color:#67C23A;;">{{parseInt(exam.paperNum)}}</span>人</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='3' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 预警信息 </p>
                        <div style="width:100%;position: relative;display:flex;" :style="{'height':element.height+'rem'}">
                            <div style="width:40%;height:100%;position: relative;display: flex;">
                                <div style="width:200rem;height:100%;position: relative;display:flex;flex-wrap:wrap;justify-content: flex-start;align-content: flex-start;left: 24rem;">
                                    <p style="width:100%;padding-left: 20rem;text-align: left;"><span style="display: inline-block;width:40rem;margin-right: 10rem;height:20rem;background:#fdd100;"></span> 塔吊</p>
                                    <p style="width:100%;padding-left: 20rem;text-align: left;"><span style="display: inline-block;width:40rem;margin-right: 10rem;height:20rem;background:#3fecff;"></span> 卸料平台</p>
                                    <p style="width:100%;padding-left: 20rem;text-align: left;"><span style="display: inline-block;width:40rem;margin-right: 10rem;height:20rem;background:#007cff;"></span> 升降机</p>
                                    <p style="width:100%;padding-left: 20rem;text-align: left;"><span style="display: inline-block;width:40rem;margin-right: 10rem;height:20rem;background:#ed5400;"></span> 深基坑</p>
                                    <p style="width:100%;padding-left: 20rem;text-align: left;"><span style="display: inline-block;width:40rem;margin-right: 10rem;height:20rem;background:#7351e3;"></span> 高支模</p>
                                    <p style="width:100%;padding-left: 20rem;text-align: left;"><span style="display: inline-block;width:40rem;margin-right: 10rem;height:20rem;background:#FF4873;"></span> 混凝土</p>
                                </div>
                                <div id="warnChart" style="width:calc( 100% - 200rem ); height:100%;"></div>
                            </div>
                            <div style="width:60%;height:100%;position: relative;padding:40rem;">
                                <div style="width:100%;height:100%;position: relative;overflow: hidden;border-left:1px solid #00E4FF;padding-left:100rem;">
                                    <div class="warn-right" :class="{anim1:animate1==true}">
                                        <div v-for="(item,index) in warnList" :key="index" style="width:100%;height:120rem;position: relative;display:flex;background: rgba(19, 145, 218, 0.2);border: 1px solid #1391DA;margin-bottom: 40rem;">
                                            <div style="width:118rem;height:118rem;position: relative;border: 1px solid #0D7992;border-radius: 8rem;display: flex;justify-content: center;align-items: center;">
                                                <img :src="item.icon" style="max-width:100%;max-height:100%;" />
                                            </div>
                                            <div style="width:calc( 100% - 240rem );height:100%;position: relative;display:flex;flex-wrap:wrap;padding-left:10rem;">
                                                <p style="width:100%;height:33%;position: relative;text-align: left;">{{item.jpushTitle}}</p>
                                                <p class="nowrap" :title="item.jpushMsg" style="width:100%;height:33%;position: relative;text-align: left;">{{item.jpushMsg}}</p>
                                                <p style="width:100%;height:33%;position: relative;text-align: left;">预警时间：{{item.createDate}}</p>
                                            </div>
                                            <div style="width:120rem;position: relative;padding-top:20rem;">
                                                <span v-if="item.isRead=='0'" style="padding:10rem 20rem;background:red;color:#fff;font-size:16rem;">待处理</span>
                                                <span v-else-if="item.isRead=='1'" style="padding:10rem 20rem;background:#67C23A;color:#fff;font-size:16rem;">已处理</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='4' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 质量安全 </p>
                        <div style="width:100%;position: relative;display:flex;" :style="{'height':element.height+'rem'}">
                            <div id="safe1" style="width:50%; height:380rem;"></div>
                            <div style="width: 50%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                <div style="width:100%;padding-left:20rem;display:flex;align-items: center;">
                                    <p style="width: 50%;position: relative;height: 20rem;top: -10rem;"><el-progress :text-inside="true" :percentage="parseFloat(qsChar.proReadLv)" :stroke-width="20" color="#1de8f1"></el-progress></p>
                                    <p style="color:#fff;display:flex;padding-left:20rem;">已处理({{qsChar.projectProcessedCount}}/{{qsChar.projectAllQsCount}})</p>
                                </div>
                                <div style="width:100%;padding-left:20rem;display:flex;align-items: center;">
                                    <p style="width: 50%;position: relative;height: 20rem;top: -10rem;"><el-progress :text-inside="true" :percentage="parseFloat(qsChar.proNoLv)" :stroke-width="20" color="#6566e2"></el-progress></p>
                                    <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未处理({{qsChar.projectPendingCount}}/{{qsChar.projectAllQsCount}})</p>
                                </div>
                            </div>
                        </div>
                        <!-- <p class="item-title"> 健康码管控系统 </p>
                        <div style="width:100%;height:350rem;position: relative;display:flex;">
                            <div style="width:50%;height:100%;position: relative;margin-top:20rem;padding:0 20rem;display:flex;flex-wrap:wrap;align-content: flex-start;">
                                <p style="width:100%;height:50rem;position: relative;">
                                    累计统计登记人数  {{anKang.CumulativeDay}}
                                </p>
                                <div style="width:100%;height:60rem;position: relative;display:flex;flex-wrap:wrap;justify-content: space-around;">
                                    <p><span class="crile" style="background:#0CCF93;"></span>正常绿码  {{anKang.green1}}</p>
                                    <p style="margin-left:20rem;"><span class="crile" style="background:#F8DA2A;"></span>异常黄码  {{anKang.yellow1}}</p>
                                    <p><span class="crile" style="background:#FB2121;"></span>异常红码  {{anKang.red1}}</p>
                                </div>
                                <div id="ankang1" style="width:100%;height:220rem;position: relative;padding-top:10rem;">
                                </div>
                            </div>
                            <div style="width:50%;height:100%;position: relative;margin-top:20rem;display:flex;flex-wrap:wrap;align-content: flex-start;">
                                <p style="width:100%;height:50rem;position: relative;">
                                    本月统计登记人数  {{anKang.inCumulative}}
                                </p>
                                <div style="width:100%;height:60rem;position: relative;display:flex;flex-wrap:wrap;justify-content: space-around;">
                                    <p><span class="crile" style="background:#0CCF93;"></span>正常绿码  {{anKang.green2}}</p>
                                    <p style="margin-left:20rem;"><span class="crile" style="background:#F8DA2A;"></span>异常黄码  {{anKang.yellow2}}</p>
                                    <p><span class="crile" style="background:#FB2121;"></span>异常红码  {{anKang.red2}}</p>
                                </div>
                                <div id="ankang2" style="width:100%;height:220rem;position: relative;padding-top:10rem;">
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <!-- list1（额外的） -->
                    <div v-if="element.index=='11' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title">
                            <el-popover placement="left" width="200" trigger="click" popper-class="popClass" @after-enter="showCheck" @after-leave="saveEquip">
                                <el-table :data="equipStatusList" ref="multipleTable" :show-header="false" @selection-change="handleSelectionChange">
                                    <el-table-column type="selection" width="55"></el-table-column>
                                    <el-table-column prop="name" label="名称"></el-table-column>
                                </el-table>
                                <span slot="reference">设备运行监测</span>
                            </el-popover>    
                        </p>
                        <div class="item-div" style="margin-top:20rem;padding-bottom:20rem;" :style="{'height':element.height+'rem'}">
                            <p class="item-head-p" style="height:20%;">
                                <span></span>
                                <template v-for="(item,index) in equipStatusList">
                                    <span class="b-line" :style="{ width: equipWidth + '%' }" v-if="item.show" :key="index">{{item.name}}</span>
                                </template>
                            </p>
                            <div class="item1-con" style="padding:0;height:80%;">
                                <div class="device-item" style="height:32%;">
                                    <p>总</p>
                                    <template v-for="(item,index) in equipStatusList">
                                        <p class="b-line" :style="{ width: equipWidth + '%' }" v-if="item.show" :key="index">{{item.total}}</p>
                                    </template>
                                </div>
                                <div class="device-item1" style="height:34%;">
                                    <p>在线</p>
                                    <template v-for="(item,index) in equipStatusList">
                                        <p v-if="item.show" :key="index" :style="{ width: equipWidth + '%' }">
                                            <img src="../../assets/image/vis/dev-bg.gif" style="width:70rem;height:70rem;" />
                                            <span class="item-span" style="left:0;">{{item.online}}</span>
                                        </p>
                                    </template>
                                </div>
                                <div class="device-item1" style="height:34%;">
                                    <p>离线</p>
                                    <template v-for="(item,index) in equipStatusList">
                                        <p v-if="item.show" :key="index" :style="{ width: equipWidth + '%' }">
                                            <img src="../../assets/image/vis/dev-bg1.png" style="width:80rem;height:80rem;" />
                                            <span class="item-span" style="left:0;top:0;">{{item.offline}}</span>
                                        </p>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='12' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 大危险源监测 </p>
                        <div style="width:100%;padding:20rem;overflow: hidden;" :style="{'height':element.height+'rem'}">
                            <div :class="{anim3:animate3==true}">
                                <div v-for="(item,index) in hazardList" :key="index" style="width:50%;height:150rem;position: relative;padding:0 10rem;float: left;">
                                    <div style="width:100%;height:120rem;position: relative;display:flex;background: rgba(19, 145, 218, 0.2);border: 1px solid #1391DA;margin-bottom: 40rem;">
                                        <div style="width:118rem;height:118rem;position: relative;border: 1px solid #0D7992;border-radius: 8rem;display: flex;justify-content: center;align-items: center;">
                                            <img :src="item.icon" style="max-width:100%;max-height:100%;" />
                                        </div>
                                        <div style="width:calc( 100% - 240rem );height:100%;position: relative;display:flex;flex-wrap:wrap;padding-left:10rem;">
                                            <p style="width:100%;height:33%;position: relative;text-align: left;">{{item.name}}</p>
                                            <p v-if="item.type!='卸料平台'" style="width:100%;height:33%;position: relative;text-align: left;">高度：<span v-if="item.height && item.height!=''&& item.height!='null'">{{item.height}} m</span></p>
                                            <p v-if="item.type=='塔吊'" style="width:100%;height:33%;position: relative;text-align: left;">风速：<span v-if="item.windSpeed && item.windSpeed!=''&& item.windSpeed!='null' ">{{item.windSpeed}} m/s</span></p>
                                            <p v-if="item.type!='塔吊'" style="width:100%;height:33%;position: relative;text-align: left;">重量：<span v-if="item.weight && item.weight!=''&& item.weight!='null'">{{item.weight}} T</span></p>
                                        </div>
                                        <div style="width:120rem;position: relative;padding-top:20rem;">
                                            <span v-if="item.status=='1'" style="padding:10rem 20rem;background:#1CAA05;color:#fff;font-size:16rem;">正常</span>
                                            <span v-else-if="item.status=='2'" style="padding:10rem 20rem;background:#D51313;color:#fff;font-size:16rem;">异常</span>
                                            <span v-else style="padding:10rem 20rem;background:#9B9B9B;color:#fff;font-size:16rem;">离线</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='13' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 扬尘监测 </p>
                        <div style="width:100%;height:400rem;position: relative;margin-top:20rem;display:flex;" :style="{'height':element.height+'rem'}">
                            <div style="width:66%;height:100%;position: relative;">
                                <div id="dust1" style="width:100%; height:100%;"></div>
                            </div>
                            <div style="width:34%;height:100%;position: relative;">
                                <div id="dust2" style="width:100%; height:100%;"></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='14' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 人员实名制 </p>
                        <div style="width:100%;height:510rem;position: relative;display:flex;flex-wrap:wrap;" :style="{'height':element.height+'rem'}">
                            <div style="width:40%;height:100%;position: relative;">
                                <div id="realChart" style="width:100%; height:400rem;"></div>
                                <div style="width:100%;height:70rem;position: relative;display:flex;">
                                    <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;align-content: center;">
                                        <p style="width:100%;text-align: center;">劳务工人数</p>
                                        <p style="width:100%;text-align: center;">{{realNum.allWorkPerson}}人</p>
                                    </div>
                                    <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;align-content: center;">
                                        <p style="width:100%;text-align: center;">进场出勤</p>
                                        <p style="width:100%;text-align: center;">{{realNum.attendancePerson}}人</p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:60%;height:100%;position: relative;padding:34rem 40rem;">
                                <div style="width:100%;height:100%;position: relative;overflow: hidden;border-left:1px solid #00E4FF;padding-left:30rem;">
                                    <div :class="{anim2:animate2==true}">
                                        <div v-for="(item,index) in realList" :key="index" style="width:100%;height:165rem;position: relative;display:flex;margin-bottom: 20rem;">
                                            <div style="width:170rem;height:100%;position: relative;">
                                                <img :src="item.uploadFile" style="width:160rem;height:162rem;" />
                                            </div>
                                            <div style="width:calc( 100% - 120rem );height:100%;position: relative;display:flex;flex-wrap:wrap;padding-left:20rem;">
                                                <p style="width:100%;height:33%;position: relative;text-align: left;">姓名：{{item.personName}}</p>
                                                <p style="width:100%;height:33%;position: relative;text-align: left;">岗位：{{item.jobs}}</p>
                                                <p style="width:100%;height:33%;position: relative;text-align: left;">时间：{{item.time}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </draggable>
        </div>
        
        <div style="width:2640rem;height:1950rem; position: relative;display:flex;flex-wrap:wrap;margin:0;padding:0 20rem;">
            <div style="width:2600rem;height:100%;display:flex;flex-wrap:wrap;align-content: flex-start;">
                <div style="width:100%;height:265rem;padding-left:0rem;display: flex;justify-content: space-around;align-content: center;align-items: center;padding-top: 40rem;">
                    <div style="width:356rem;height:164rem;position: relative;border-radius: 5rem;background: linear-gradient(360deg, #0E4CC7 0%, #0374DE 100%, #0374DE 100%);display:flex;align-content: center;flex-wrap:wrap;">
                        <p style="width:100%;text-align: center;font-size:36rem;">{{proInfo.allDay}}</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">总工期</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">（天）</p>
                    </div>
                    <div style="width:356rem;height:164rem;position: relative;border-radius: 5rem;background: linear-gradient(360deg, #006FC7 0%, #00B6D5 100%, #00B6D5 100%);display:flex;align-content: center;flex-wrap:wrap;">
                        <p style="width:100%;text-align: center;font-size:36rem;">{{proInfo.planDays}}</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">计划进度</p>
                    </div>
                    <div style="width:356rem;height:164rem;position: relative;border-radius: 5rem;background: linear-gradient(360deg, #0C47CF 0%, #5D05D6 100%, #5D05D6 100%);display:flex;align-content: center;flex-wrap:wrap;">
                        <p style="width:100%;text-align: center;font-size:36rem;">{{ proInfo.otherDay}}</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">剩余天数</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">（天）</p>
                    </div>
                    <div style="width:356rem;height:164rem;position: relative;border-radius: 5rem;background: linear-gradient(360deg, #260EAA 0%, #0475DB 100%, #0475DB 100%);display:flex;align-content: center;flex-wrap:wrap;">
                        <p style="width:100%;text-align: center;font-size:36rem;">{{proInfo.settlementValue}}</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">进度产值</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">（万元）</p>
                    </div>
                </div>
                <div style="width:100%;height:920rem;position: relative;background: rgba(13, 25, 57, 0.45);border: 2px solid #707070;padding:0 60rem;">
                    <p class="item-title"> BIM </p>
                    <div style="width:100%;height:800rem;margin-top:30rem;position: relative;">
                        <iframe width="100%" height="100%" :src='bimUrl' style="border: 0;height: 100%;"></iframe>
                    </div>
                </div>
                <div style="width:100%;height:715rem;position: relative;display:flex;justify-content: space-between;">
                    <!-- <div class="item-div borderCss" style="margin-top:20rem;width:1460rem;">
                        <p class="item-title"> 现场监控 </p>
                        <div style="width:100%;height:600rem;position: relative;padding:20rem;display: flex;flex-wrap: wrap;align-content: flex-start;justify-content: flex-start;">
                            <div class="monitorbox-item" v-for="(item,index) in monitorList" :key="index">
                                <div class="item-monitor">
                                    <iframe width="100%" height="100%" :src='item.showUrl' style="border: 0;height: 100%;"></iframe>
                                </div>
                                <p class="item-info">
                                    <span class="name nowrap">{{item.name}}</span>
                                    <img v-if="item.type=='1'" src="../../assets/image/visual/gun.png" />
                                    <img v-else-if="item.type=='2'" src="../../assets/image/visual/ptz.png" />
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="item-div borderCss" style="margin-top:20rem;width:1100rem;">
                        <p class="item-title"> 塔吊监控 
                            <span class="tower-video-sel" style="position: absolute;top: 5rem;right: -160rem;width: 300rem;">
                                <el-select v-model="towerIndex" @change="changeTower" popper-class="video-towers">
                                    <el-option v-for="(item,index) in towerList" :key="item.id" :label="item.name" :value="index" :disabled="!item.cameraFlag"></el-option>
                                </el-select>
                            </span>
                        </p>
                        <div style="width:100%;height:600rem;position: relative;display:flex;margin-top: 30rem;">
                            <iframe width="100%" height="100%" :src='towerVideo' style="border: 0;height: 100%;"></iframe>
                        </div>
                    </div> -->
                    <div class="item-div borderCss" style="margin-top:20rem;width:100%;">
                        <i class="el-icon-s-tools" @click="showMonitorDig" style="color:#fff;position: absolute;top: 20rem;right: 30rem;cursor: pointer;font-size: 50rem;"></i>
                        <p class="item-title"> 现场监控 </p>
                        <div style="width:100%;height:640rem;position: relative;padding:20rem;display: flex;flex-wrap: wrap;align-content: flex-start;justify-content: flex-start;">
                            <div class="monitorbox-item" v-for="(item,index) in monitorList" :key="index">
                                <div class="item-monitor">
                                    <iframe width="100%" height="100%" :src='item.showUrl' style="border: 0;height: 100%;"></iframe>
                                </div>
                                <!-- <p class="item-info">
                                    <span class="name nowrap">{{item.name}}</span>
                                    <img v-if="item.type=='1'" src="../../assets/image/visual/gun.png" />
                                    <img v-else-if="item.type=='2'" src="../../assets/image/visual/ptz.png" />
                                </p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="list-group-box1">
            <draggable class="list-group" tag="ul" :list="list1" group="project" @change="log" style="background:transparent;">
                <li class="list-group-item" v-for="(element, index) in list1" :key="index">
                    <div v-if="element.index=='11' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title">
                            <el-popover placement="left" width="200" trigger="click" popper-class="popClass" @after-enter="showCheck" @after-leave="saveEquip">
                                <el-table :data="equipStatusList" ref="multipleTable" :show-header="false" @selection-change="handleSelectionChange">
                                    <el-table-column type="selection" width="55"></el-table-column>
                                    <el-table-column prop="name" label="名称"></el-table-column>
                                </el-table>
                                <span slot="reference">设备运行监测</span>
                            </el-popover>    
                        </p>
                        <div class="item-div" style="margin-top:20rem;padding-bottom:20rem;" :style="{'height':element.height+'rem'}">
                            <p class="item-head-p" style="height:20%;">
                                <span></span>
                                <template v-for="(item,index) in equipStatusList">
                                    <span class="b-line" :style="{ width: equipWidth + '%' }" v-if="item.show" :key="index">{{item.name}}</span>
                                </template>
                            </p>
                            <div class="item1-con" style="padding:0;height:80%;">
                                <div class="device-item" style="height:32%;">
                                    <p>总</p>
                                    <template v-for="(item,index) in equipStatusList">
                                        <p class="b-line" :style="{ width: equipWidth + '%' }" v-if="item.show" :key="index">{{item.total}}</p>
                                    </template>
                                </div>
                                <div class="device-item1" style="height:34%;">
                                    <p>在线</p>
                                    <template v-for="(item,index) in equipStatusList">
                                        <p v-if="item.show" :key="index" :style="{ width: equipWidth + '%' }">
                                            <img src="../../assets/image/vis/dev-bg.gif" style="width:70rem;height:70rem;" />
                                            <span class="item-span" style="left:0;">{{item.online}}</span>
                                        </p>
                                    </template>
                                </div>
                                <div class="device-item1" style="height:34%;">
                                    <p>离线</p>
                                    <template v-for="(item,index) in equipStatusList">
                                        <p v-if="item.show" :key="index" :style="{ width: equipWidth + '%' }">
                                            <img src="../../assets/image/vis/dev-bg1.png" style="width:80rem;height:80rem;" />
                                            <span class="item-span" style="left:0;top:0;">{{item.offline}}</span>
                                        </p>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='12' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 大危险源监测 </p>
                        <div style="width:100%;padding:20rem;overflow: hidden;" :style="{'height':element.height+'rem'}">
                            <div :class="{anim3:animate3==true}">
                                <div v-for="(item,index) in hazardList" :key="index" style="width:50%;height:150rem;position: relative;padding:0 10rem;float: left;">
                                    <div style="width:100%;height:120rem;position: relative;display:flex;background: rgba(19, 145, 218, 0.2);border: 1px solid #1391DA;margin-bottom: 40rem;">
                                        <div style="width:118rem;height:118rem;position: relative;border: 1px solid #0D7992;border-radius: 8rem;display: flex;justify-content: center;align-items: center;">
                                            <img :src="item.icon" style="max-width:100%;max-height:100%;" />
                                        </div>
                                        <div style="width:calc( 100% - 240rem );height:100%;position: relative;display:flex;flex-wrap:wrap;padding-left:10rem;">
                                            <p style="width:100%;height:33%;position: relative;text-align: left;">{{item.name}}</p>
                                            <p v-if="item.type!='卸料平台'" style="width:100%;height:33%;position: relative;text-align: left;">高度：<span v-if="item.height && item.height!=''&& item.height!='null'">{{item.height}} m</span></p>
                                            <p style="width:100%;height:33%;position: relative;text-align: left;">重量：<span v-if="item.weight && item.weight!=''&& item.weight!='null'">{{item.weight}} T</span></p>
                                        </div>
                                        <div style="width:120rem;position: relative;padding-top:20rem;">
                                            <span v-if="item.status=='1'" style="padding:10rem 20rem;background:#1CAA05;color:#fff;font-size:16rem;">正常</span>
                                            <span v-else-if="item.status=='2'" style="padding:10rem 20rem;background:#D51313;color:#fff;font-size:16rem;">异常</span>
                                            <span v-else style="padding:10rem 20rem;background:#9B9B9B;color:#fff;font-size:16rem;">离线</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='13' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 扬尘监测 </p>
                        <div style="width:100%;height:400rem;position: relative;margin-top:20rem;display:flex;" :style="{'height':element.height+'rem'}">
                            <div style="width:66%;height:100%;position: relative;">
                                <div id="dust1" style="width:100%; height:100%;"></div>
                            </div>
                            <div style="width:34%;height:100%;position: relative;">
                                <div id="dust2" style="width:100%; height:100%;"></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='14' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 人员实名制 </p>
                        <div style="width:100%;height:510rem;position: relative;display:flex;flex-wrap:wrap;" :style="{'height':element.height+'rem'}">
                            <div style="width:40%;height:100%;position: relative;">
                                <div id="realChart" style="width:100%; height:400rem;"></div>
                                <div style="width:100%;height:70rem;position: relative;display:flex;">
                                    <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;align-content: center;">
                                        <p style="width:100%;text-align: center;">劳务工人数</p>
                                        <p style="width:100%;text-align: center;">{{realNum.allWorkPerson}}人</p>
                                    </div>
                                    <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;align-content: center;">
                                        <p style="width:100%;text-align: center;">进场出勤</p>
                                        <p style="width:100%;text-align: center;">{{realNum.attendancePerson}}人</p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:60%;height:100%;position: relative;padding:34rem 40rem;">
                                <div style="width:100%;height:100%;position: relative;overflow: hidden;border-left:1px solid #00E4FF;padding-left:30rem;">
                                    <div :class="{anim2:animate2==true}">
                                        <div v-for="(item,index) in realList" :key="index" style="width:100%;height:165rem;position: relative;display:flex;margin-bottom: 20rem;">
                                            <div style="width:170rem;height:100%;position: relative;">
                                                <img :src="item.uploadFile" style="width:160rem;height:162rem;" />
                                            </div>
                                            <div style="width:calc( 100% - 120rem );height:100%;position: relative;display:flex;flex-wrap:wrap;padding-left:20rem;">
                                                <p style="width:100%;height:33%;position: relative;text-align: left;">姓名：{{item.personName}}</p>
                                                <p style="width:100%;height:33%;position: relative;text-align: left;">岗位：{{item.jobs}}</p>
                                                <p style="width:100%;height:33%;position: relative;text-align: left;">时间：{{item.time}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- list0（额外） -->
                    <div v-if="element.index=='1' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 人员动态 </p>
                        <div style="width:100%;position: relative;" :style="{'height':element.height+'rem'}">
                            <div style="width:100%;height:11%;position: relative;display:flex;padding:0 0 0 36rem;align-items: center;">
                                <p style="font-size:28rem;color:#fff;padding-left:10rem;">累计采集{{syn.zs}}人</p>
                                <p style="font-size:28rem;color:#fff;padding-left:30rem;">实名占比{{syn.smRate}}</p>
                            </div>
                            <div style="width:100%;height:89%;position: relative;display:flex;">
                                <div style="width: 40%;height: 100%;">
                                    <div id="myChart1" style="width:100%; height:100%;"></div>
                                </div>
                                <div style="width: 60%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                    <div style="width:100%;padding-left:20rem;display:flex;align-items: center;">
                                        <p style="width: 50%;position: relative;height: 20rem;top: -10rem;"><el-progress :text-inside="true" :percentage="parseFloat(syn.zzLv)" :stroke-width="20"></el-progress></p>
                                        <p style="color:#fff;display:flex;padding-left:20rem;">在职人员({{syn.zz}}/{{syn.zs}})</p>
                                    </div>
                                    <div style="width:100%;padding-left:20rem;display:flex;align-items: center;">
                                        <p style="width: 50%;position: relative;height: 20rem;top: -10rem;"><el-progress :text-inside="true" :percentage="parseFloat(syn.lzLv)" :stroke-width="20" color="#FF9F20"></el-progress></p>
                                        <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">离职人员({{syn.lz}}/{{syn.zs}})</p>
                                    </div>
                                    <div style="width:100%;padding-left:20rem;display:flex;align-items: center;">
                                        <p style="width: 50%;position: relative;height: 20rem;top: -10rem;"><el-progress :text-inside="true" :percentage="parseFloat(syn.wzzLv)" :stroke-width="20" color="#64EBA8"></el-progress></p>
                                        <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未分配人员({{syn.wzz}}/{{syn.zs}})</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='2' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 安全教育 </p>
                        <div style="width:100%;position: relative;display:flex;" :style="{'height':element.height+'rem'}">
                            <div style="width:50%;height:100%;position: relative;">
                                <div id="eduChart" style="width:100%; height:100%;"></div>
                                <p style="position: absolute;right:80rem;bottom: 20rem;">受教育人数   <span style="color:#67C23A;;">{{parseInt(exam.educationNum)}}</span>人</p>
                            </div>
                            <div style="width:50%;height:100%;position: relative;">
                                <div id="examChart" style="width:100%; height:100%;"></div>
                                <p style="position: absolute;right:80rem;bottom: 20rem;">入职考试人数   <span style="color:#67C23A;;">{{parseInt(exam.paperNum)}}</span>人</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='3' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 预警信息 </p>
                        <div style="width:100%;position: relative;display:flex;" :style="{'height':element.height+'rem'}">
                            <div style="width:40%;height:100%;position: relative;">
                                <div id="warnChart" style="width:100%; height:100%;"></div>
                            </div>
                            <div style="width:60%;height:100%;position: relative;padding:40rem;">
                                <div style="width:100%;height:100%;position: relative;overflow: hidden;border-left:1px solid #00E4FF;padding-left:100rem;">
                                    <div class="warn-right" :class="{anim1:animate1==true}">
                                        <div v-for="(item,index) in warnList" :key="index" style="width:100%;height:120rem;position: relative;display:flex;background: rgba(19, 145, 218, 0.2);border: 1px solid #1391DA;margin-bottom: 40rem;">
                                            <div style="width:118rem;height:118rem;position: relative;border: 1px solid #0D7992;border-radius: 8rem;display: flex;justify-content: center;align-items: center;">
                                                <img :src="item.icon" style="max-width:100%;max-height:100%;" />
                                            </div>
                                            <div style="width:calc( 100% - 240rem );height:100%;position: relative;display:flex;flex-wrap:wrap;padding-left:10rem;">
                                                <p style="width:100%;height:33%;position: relative;text-align: left;">{{item.jpushTitle}}</p>
                                                <p class="nowrap" :title="item.jpushMsg" style="width:100%;height:33%;position: relative;text-align: left;">{{item.jpushMsg}}</p>
                                                <p style="width:100%;height:33%;position: relative;text-align: left;">预警时间：{{item.createDate}}</p>
                                            </div>
                                            <div style="width:120rem;position: relative;padding-top:20rem;">
                                                <span v-if="item.isRead=='0'" style="padding:10rem 20rem;background:red;color:#fff;font-size:16rem;">待处理</span>
                                                <span v-else-if="item.isRead=='1'" style="padding:10rem 20rem;background:#67C23A;color:#fff;font-size:16rem;">已处理</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='4' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 质量安全 </p>
                        <div style="width:100%;position: relative;display:flex;" :style="{'height':element.height+'rem'}">
                            <div id="safe1" style="width:50%; height:380rem;"></div>
                            <div style="width: 50%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                <div style="width:100%;padding-left:20rem;display:flex;align-items: center;">
                                    <p style="width: 50%;position: relative;height: 20rem;top: -10rem;"><el-progress :text-inside="true" :percentage="parseFloat(qsChar.proReadLv)" :stroke-width="20" color="#1de8f1"></el-progress></p>
                                    <p style="color:#fff;display:flex;padding-left:20rem;">已处理({{qsChar.projectProcessedCount}}/{{qsChar.projectAllQsCount}})</p>
                                </div>
                                <div style="width:100%;padding-left:20rem;display:flex;align-items: center;">
                                    <p style="width: 50%;position: relative;height: 20rem;top: -10rem;"><el-progress :text-inside="true" :percentage="parseFloat(qsChar.proNoLv)" :stroke-width="20" color="#6566e2"></el-progress></p>
                                    <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未处理({{qsChar.projectPendingCount}}/{{qsChar.projectAllQsCount}})</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </draggable>
            <i class="el-icon-s-tools" style="color:#fff;position: absolute;right: -50rem;top: -50rem;font-size: 50rem;cursor: pointer;" @click="showDialogFun"></i>
        </div>

        <el-dialog
            title="提示"
            :visible.sync="ctrlVis"
            width="2315rem"
            :lock-scroll="false"
            custom-class="bigVitalDia"
            style="height:2600rem;"
        >
            <div style="width:100%;height:auto;position: relative;">
                <div style="width:100%;height:60rem;position: relative;display:flex;">
                    <p style="width:15%;text-align: center;">适配（像素）</p>
                    <p style="width:20%;text-align: center;">名称</p>
                    <p style="width:15%;text-align: center;">间距（像素）</p>
                    <p style="width:25%;text-align: center;">边框</p>
                    <p style="width:25%;text-align: center;">状态</p>
                </div>
                <ul>
                    <li v-for="(item,index) in modularList" :key="index" style="width:100%;height:60rem;display:flex;margin-top:20rem;align-items: center;">
                        <p style="width:15%;text-align: center;display: flex;align-items: center;">
                            {{item.width}} * <el-input v-model="item.height" type="number" style="width:200rem;margin-left:10rem"></el-input>
                        </p>
                        <p style="width:20%;text-align: center;">{{item.name}}</p>
                        <p style="width:15%;text-align: center;">
                            <el-input v-model="item.margin" type="number" placeholder=""></el-input>
                        </p>
                        <p style="width:25%;text-align: center;">
                            <el-radio-group v-model="item.border">
                                <el-radio :label="false">隐藏</el-radio>
                                <el-radio :label="true">显示</el-radio>
                            </el-radio-group>
                        </p>
                        <p style="width:25%;text-align: center;">
                            <el-radio-group v-model="item.show">
                                <el-radio :label="true">开启</el-radio>
                                <el-radio :label="false">关闭</el-radio>
                            </el-radio-group>
                        </p>
                    </li>
                </ul>
                <div style="margin-top:30rem;">
                    <el-button @click="ctrlVis = false" style="margin-right:20rem;">取 消</el-button>
                    <el-button @click="refreshCtl" style="margin-left:20rem;">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 监控检查 -->
        <el-dialog
            title="监控配置"
            :visible.sync="monitorVis"
            width="2000rem"
            :lock-scroll="false"
            custom-class="bigVitalDia"
            style="height:2400rem;"
        >
            <div style="width:100%;height:auto;position: relative;">
                <el-table
                    ref="monitorTable"
                    :data="allMonitorList"
                    tooltip-effect="dark"
                    style="width: 100%"
                    height="600"
                    @selection-change="monitorSelectionChange">
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column label="名称" >
                        <template slot-scope="scope">{{ scope.row.name }}</template>
                    </el-table-column>
                    <el-table-column label="类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.useType=='1'">普通设备</span>
                            <span v-else-if="scope.row.useType=='2'">塔吊设备</span>
                            <span v-else-if="scope.row.useType=='3'">入口设备</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top:30rem;">
                    <el-button @click="cancleMonitor" style="margin-right:20rem;">取 消</el-button>
                    <el-button @click="subMonitorCtl" style="margin-left:20rem;">确 定</el-button>
                </div>
            </div>
        </el-dialog>
        <div style="width:6vh;height:6vh;position:fixed;top: 40rem;left: 80rem;display: flex;justify-content: center;align-items: center;">
            <img @click="goBackFun" src="../../assets/image/back1.png" style="width:64rem;height:64rem;position: relative;cursor: pointer;">
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable"
import Highcharts from 'highcharts'
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
// import $ from jquery
export default {
    components: {
        draggable
    },
    data(){
        return{
            timeout:300000, //普通
            // timeout1:600000,//班组出勤+合同
            drag: false,
            list0:[
                {name:'人员动态',index:"1",order:0,margin:20,show:true,width:860,border:true,height:450,},
                {name:'安全教育',index:"2",order:1,margin:20,show:true,width:860,border:true,height:400,},
                {name:'预警信息',index:"3",order:2,margin:20,show:true,width:860,border:true,height:380,},
                {name:'质量安全',index:"4",order:3,margin:20,show:true,width:860,border:true,height:350,},
            ],
            list1:[
                {name:'设备运行监测',index:"11",order:0,margin:20,show:true,width:860,border:true,height:308},
                {name:'大危险源监测',index:"12",order:1,margin:20,show:true,width:860,border:true,height:320},
                {name:'扬尘监测',index:"13",order:2,margin:20,show:true,width:860,border:true,height:400},
                {name:'人员实名制',index:"14",order:2,margin:20,show:true,width:860,border:true,height:510},
            ],
            listMid:[
                // {name:'现场监控',index:"50",order:2,margin:0,show:false,width:860,border:true},
            ],
            allList:[  //页面操作弹出框
                {name:'人员动态',index:"1",order:0,margin:20,show:true,width:860,border:true,height:450},
                {name:'安全教育',index:"2",order:1,margin:20,show:true,width:860,border:true,height:400},
                {name:'预警信息',index:"3",order:2,margin:20,show:true,width:860,border:true,height:380},
                {name:'质量安全',index:"4",order:3,margin:20,show:true,width:860,border:true,height:350},
                {name:'设备运行监测',index:"11",order:0,margin:20,show:true,width:860,border:true,height:308},
                {name:'大危险源监测',index:"12",order:1,margin:20,show:true,width:860,border:true,height:320},
                {name:'扬尘监测',index:"13",order:2,margin:20,show:true,width:860,border:true,height:400},
                {name:'人员实名制',index:"14",order:2,margin:20,show:true,width:860,border:true,height:510},
                // {name:'塔吊监控',index:"50",order:2,margin:0,show:false,width:860,border:true},
            ],
            //定时器集合
            pageTimer:{}, //定义计算器全局变量
            curTime:util.myTime.getAllTime(),//当前时间

            proInfo:{
                allDay: 0,
                name: "",
                otherDay: 0,
                planDays: 0,
                settlementTotal: 0,
                settlementValue: 0,
            },//项目信息
            syn:{ //人员动态
                zz:0,   //在职
                lz:0,   //离职
                wzz:0,  //未入职
                wsm:0,  //未实名
                sm:0,   //采集人数
                zs:0,   //总人数
                smRate:0,//实名率
                zzLv:0,  //在职比例
                wzzLv:0, //未在职比例
                lzLv:0, //未实名比例
            },
            //健康码管控系统
            // anKang:{
            //     CumulativeDay: 100,
            //     green1: 90,
            //     green2: 90,
            //     inCumulative: 100,
            //     red1: 1,
            //     red2: 1,
            //     yellow1: 9,
            //     yellow2: 9,
            // },
            //人员实名制
            realList:[],
            realNum:{
                allWorkPerson:0,
                attendancePerson:0
            },
            //质量安全
            qsChar:{
                entAllQsCount: 0,
                entNoProblemCount: 0,
                entPendingCount: 0,
                entProblemCount: 0,
                entProcessedCount: 0,
                projectAllQsCount: 0,
                projectNoProblemCount: 0,
                projectPendingCount: 0,
                projectProblemCount: 0,
                projectProcessedCount: 0,
                proReadLv:0,
                proNoLv:0
            },
            //设备运行监测
            equipStatusList:[
                {total:'0',online:'0',offline:'0',name:'考勤机',show:true,id:'1'},
                {total:'0',online:'0',offline:'0',name:'塔吊设备',show:true,id:'2'},
                {total:'0',online:'0',offline:'0',name:'视频监控',show:true,id:'3'},
                {total:'0',online:'0',offline:'0',name:'升降机',show:true,id:'4'},
                {total:'0',online:'0',offline:'0',name:'螺母设备',show:true,id:'5'},
                {total:'0',online:'0',offline:'0',name:'卸料设备',show:true,id:'6'},
                {total:'0',online:'0',offline:'0',name:'能耗监测',show:true,id:'7'},
                {total:'0',online:'0',offline:'0',name:'混凝土',show:true,id:'8'},
            ],
            equipWidth:'14',
            tableEquip:[],//弹出框中数据
            monitorList:[],//展示监控列表
            allMonitorList:[],//所有监控列表
            selMonitorList:[],//选中的监控列表
            monitorVis:false,
            ysToken:'',
            warnList:[],//预警列表
            exam:{
                paperNum:0,
                other:0
            },
            edu:{
                paperNum:0,
                other:0
            },
            //塔吊可视化
            towerList:[],
            towerVideo:'',
            towerIndex:'',
            towerLoad:false,
            //大危险源监测
            hazardList:[],

            animate1:false,
            animate2:false,
            animate3:false,

            moduleExeit:false,
            //弹出框
            ctrlVis:false,
            modularList:[],//模板列表（用于弹出框展示）

            //bim地址
            bimUrl:'',
        }
    },
    created(){
        var that = this
        for(var each in this.pageTimer){
            window.clearTimeout(this.pageTimer[each]);
        }
        this.pageTimer['timer0'] = setInterval(function(){
            that.curTime = util.myTime.getAllTime()
        },1000)
        this.getMonitorToken()
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getSortList()
        this.getBimList()
    },
    methods:{
        //获取展示模块数据
        getSortList(){
            var that = this
            myHttp.selectHomePage({
                groupId:this.groupId,
                type:'4'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.HomePage
                    if(data){
                        var list = JSON.parse(data.numerical)
                        var list0 = JSON.parse(JSON.stringify(that.list0))
                        var list1 = JSON.parse(JSON.stringify(that.list1))
                        that.list0 = []
                        that.list1 = []
                        that.list0 = that.filterModult(list0,list,0)
                        that.list1 = that.filterModult(list1,list,1)
                        
                        that.moduleExeit = true
                        //重新赋值
                        for(var i=0;i<list.length;i++){
                            for(var j=0;j<list[i].length;j++){
                                for(var k=0;k<that.allList.length;k++){
                                    if(list[i][j].index==that.allList[k].index){
                                        that.allList[k].margin =  list[i][j].margin
                                        that.allList[k].show =  list[i][j].show
                                        that.allList[k].border =  list[i][j].border
                                        that.allList[k].height =  list[i][j].height||that.allList[k].height
                                    }
                                }
                            }
                        }
                        // that.clearEchart()
                        // that.getSynData() //获取人员动态（位置改变后重新渲染）
                        // that.getWarnInfo() //预警信息（位置改变后重新渲染）
                        // that.getQsData() //质量安全
                        // that.getEduFun()  //安全教育（位置改变后重新渲染）
                        // that.getDustLine() //扬尘设备-24小时（位置改变后重新渲染）
                        // that.getDustPie()  //扬尘设备 - PM2.5（位置改变后重新渲染）
                        // that.getRealName() //实名制
                        that.setMonitorShow(list)//展示选择的监控
                        that.setEquipStatus(list) // 设备运行状态
                        
                    }else{
                        that.getMonitorList()  //现场监控
                    }
                    that.loadFun()
                }else{
                    that.loadFun()
                    that.getMonitorList()  //现场监控
                }
            },function(){that.loadFun()})
        },
        //加载数据
        loadFun(){
            this.getProjectInfo()
            this.getSynData() //获取人员动态
            this.getWarnInfo() //预警信息
            this.getEduFun()  //安全教育
            // this.getAnKang() //项目健康码
            this.getRealName() //实名制
            this.getQsData() //质量安全
            this.getMacType() //设备运行状态
            this.getHazardList() //大危险源监测
            this.getDustLine() //扬尘设备-24小时
            this.getDustPie()  //扬尘设备 - PM2.5
            // this.getMonitorList()  //现场监控
            this.getTowerList() //塔吊列表
        },
        
        //对新模块进行兼容
        filterModult(list,all,col){
            for(var i=0;i<all.length;i++){
                for(var j=0;j<all[i].length;j++){
                    for(var k=0;k<list.length;k++){
                        if(list[k].index==all[i][j].index){
                            list[k].isExit =true
                        }
                    }
                }
            }
            for(var i=0;i<list.length;i++){
                if(!list[i].isExit){
                    all[col].push(list[i])
                }
            }
            return all[col]
        },
        //设置设备运行监测展示状态
        setEquipStatus(list){
            var objs = list[2]||[]
            for(var i=0;i<this.equipStatusList.length;i++){
                for( var j=0;j<objs.length;j++){
                    if(this.equipStatusList[i].id == objs[j].id){
                        this.equipStatusList[i].show = objs[j].show
                    }
                }
                
            }
            var num = 0
            for(var i=0;i<this.equipStatusList.length;i++){
                if(this.equipStatusList[i].show){
                    num += 1
                }
            }
            this.equipWidth = 86/num
            
        },
        //设置展示的监控
        setMonitorShow(list){
            var objs = list[3]||[]
            this.selMonitorList = objs
            this.getMonitorList()  //现场监控
        },
        //设置质量安全 和 塔吊监控展示（某一项）
        // setTowerVideo(list){
        //     var objs = list[3]
        //     for(var i=0;i<objs.length;i++){
        //         if(objs[i].index=='50'){  //判断是否展示塔吊设备
        //             if(objs[i].show){
        //                 this.towerVideoFlag = true
        //             }else{
        //                 this.towerVideoFlag = false
        //             }
        //         }
        //     }
        //     //获取塔吊监控
        //     if(this.towerVideoFlag){
        //         this.getTowerList()
        //     }else{
        //         this.getQsData() //质量安全
        //     }
        // },
        //展示
        showCheck(){
            for(var i=0;i<this.equipStatusList.length;i++){
                if(this.equipStatusList[i].show){
                    this.$refs.multipleTable[0].toggleRowSelection(this.equipStatusList[i],true);
                }
            }
        },
        //获取监控视频token
        getMonitorToken(){
            var that = this
            myHttp.getYsToken({
              projectId: this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.ysToken = resp.data.data.accessToken||''
                }
            })
        },
        /**项目信息 ************************************/
        getProjectInfo(){
            var that = this
            myHttp.getProjectInfo({
                id:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.project
                    that.proInfo = data
                }
                
            })
        },
        /**
         * 人员动态
         */
        getSynData(){
            var that = this
            myHttp.personDynamic({
                projectId:this.groupId
            }).then(function(resp){
                var data = resp.data.data || {}
                data.smRate = data.zs && data.zs!='0'?(parseInt(data.sm)/parseInt(data.zs)*100).toFixed(1)+'%':'0%'
                data.zzLv = data.zs && data.zs!='0'?(parseInt(data.zz)/parseInt(data.zs)*100).toFixed(1)+'%':'0%'
                data.wzzLv = data.zs && data.zs!='0'?(parseInt(data.wzz)/parseInt(data.zs)*100).toFixed(1)+'%':'0%'
                data.lzLv = data.zs && data.zs!='0'?(parseInt(data.lz)/parseInt(data.zs)*100).toFixed(1)+'%':'0%'
                that.syn = data
                that.showSysChat()
                //先关闭定时器
                if(that.pageTimer["fun1"]){
                    window.clearTimeout(that.pageTimer["fun1"])
                }
                //定时刷新
                that.pageTimer["fun1"] = setTimeout(function(){
                    that.getSynData()
                },that.timeout)
            })
        },
        /**
         * 安全教育考试
         */
        getEduFun(){
            var that = this
            myHttp.safetyEducationPro({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    data.other = parseInt(data.allNum) - parseInt(data.paperNum||0)  //未考试的人
                    data.eduOther = data.educationNum?parseInt(data.allNum)-parseInt(data.educationNum||0):0 //未接受教育的人
                    that.exam = data
                    that.showExam(data)
                    that.showEdu(data)
                }
                //先关闭定时器
                if(that.pageTimer["fun2"]){
                    window.clearTimeout(that.pageTimer["fun2"])
                }
                //定时刷新
                that.pageTimer["fun2"] = setTimeout(function(){
                    that.getEduFun()
                },that.timeout)
            })

        },
        /**
         * 预警信息
         */
        getWarnInfo(){
            var that = this
            myHttp.selectSysJpushMsgAllPageScreen({
                projectId:this.groupId,
                pageNum:1,
                pageSize:20
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.sysJpushMsgAlls.list||[]
                    for(var i=0;i<list.length;i++){
                        if(list[i].jpushNoticeType=='3'){
                            list[i].icon = require('../../assets/image/visual/warn3.png')
                        }else if(list[i].jpushNoticeType=='4'){
                            list[i].icon = require('../../assets/image/visual/warn1.png')
                        }else if(list[i].jpushNoticeType=='5'){
                            list[i].icon = require('../../assets/image/visual/warn5.png')
                        }else if(list[i].jpushNoticeType=='6'){
                            list[i].icon = require('../../assets/image/visual/warn2.png')
                        }else if(list[i].jpushNoticeType=='7'){
                            list[i].icon = require('../../assets/image/visual/warn6.png')
                        }else if(list[i].jpushNoticeType=='8'){
                            list[i].icon = require('../../assets/image/visual/warn4.png')
                        }
                    }
                    that.warnList = list
                    if(that.pageTimer["timer1"]){
                        window.clearInterval(that.pageTimer["timer1"])
                    }
                    that.pageTimer["timer1"] = setInterval(that.scroll1,3000) // 预警信息滚动

                    //先关闭定时器
                    if(that.pageTimer["fun8"]){
                        window.clearTimeout(that.pageTimer["fun8"])
                    }
                    //定时刷新
                    that.pageTimer["fun8"] = setTimeout(function(){
                        that.getWarnInfo()
                    },that.timeout)
                }
            })
            //数量
            myHttp.selectSysJpushMsgAllCountByType({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.showWarn(data)
                }else{
                    that.showWarn()
                }
            })
        },
        /**
         * 健康码
         */
        getAnKang(){
            var that = this
            myHttp.anKangCodeByProjectIdScreen({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.anKang = data
                    that.setAllAn()
                    that.setMonthAn()
                }
                //先关闭定时器
                if(that.pageTimer["fun3"]){
                    window.clearTimeout(that.pageTimer["fun3"])
                }
                //定时刷新
                that.pageTimer["fun3"] = setTimeout(function(){
                    that.getAnKang()
                },that.timeout)
            })
        },
        /**
         * 人员实名制
         */
        getRealName(){
            var that = this
            myHttp.realName({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data[0]
                    var list = resp.data.data[1].attend||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = i
                        list[i].uploadFile = list[i].uploadFile && list[i].uploadFile!=''?base.httpCtx+list[i].uploadFile:require('../../assets/image/zanwutupian.png')
                    }
                    that.setRealName(data)
                    that.realList = list
                    that.realNum = data
                }
                if(that.pageTimer["timer2"]){
                    window.clearInterval(that.pageTimer["timer2"])
                }
                that.pageTimer["timer2"] = setInterval(that.scroll2,3000) // 预警信息滚动
            })
        },
        //获取质量安全-数据
        getQsData(){
            var that = this
            myHttp.selectProjectQsCount({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data||that.qsChar
                    that.qsChar = data
                    that.qsChar.proReadLv = (parseInt(data.projectProcessedCount)/parseInt(data.projectAllQsCount)*100).toFixed(2)
                    that.qsChar.proNoLv = (parseInt(data.projectPendingCount)/parseInt(data.projectAllQsCount)*100).toFixed(2)
                    that.setSafeChat()
                }
                //先关闭定时器
                if(that.pageTimer["fun4"]){
                    window.clearTimeout(that.pageTimer["fun4"])
                }
                //定时刷新
                that.pageTimer["fun4"] = setTimeout(function(){
                    that.getQsData()
                },that.timeout)
            })
        },
        
        /**设备运行状态 */
        getMacType(){
            var that = this
            myHttp.equipment({
                projectId:this.groupId,
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    var list = []
                    list.push({total:data.attendance.sum,online:data.attendance.online,offline:data.attendance.offline})
                    list.push({total:data.tower.sum,online:data.tower.online,offline:data.tower.offline})
                    list.push({total:data.projectMonitor.sum,online:data.projectMonitor.online,offline:data.projectMonitor.offline})
                    list.push({total:data.elevator.sum,online:data.elevator.online,offline:data.elevator.offline})
                    list.push({total:data.nutDetection.sum,online:data.nutDetection.online,offline:data.nutDetection.offline}) //螺母
                    list.push({total:data.unloadPlatform.total,online:data.unloadPlatform.online,offline:data.unloadPlatform.offline})
                    list.push({total:data.waterElectricity.sum,online:data.waterElectricity.online,offline:data.waterElectricity.offline})
                    list.push({total:data.concrete.sum,online:data.concrete.online,offline:data.concrete.offline})
                    // that.equipStatusList = list
                    for(var i=0;i<list.length;i++){
                        that.equipStatusList[i].total = list[i].total
                        that.equipStatusList[i].online = list[i].online
                        that.equipStatusList[i].offline = list[i].offline
                    }
                }
                //先关闭定时器
                if(that.pageTimer["fun5"]){
                    window.clearTimeout(that.pageTimer["fun5"])
                }
                //定时刷新
                that.pageTimer["fun5"] = setTimeout(function(){
                    that.getMacType()
                },that.timeout)
            })
        },

        //大危险源监测
        getHazardList(){
            var that = this
            myHttp.statisticsBigDangerousSource({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data||[]
                    for(var i=0;i<list.length;i++){
                        if(list[i].type=='塔吊'){
                            list[i].icon = require('../../assets/image/visual/warn3.png')
                        }else if(list[i].type=='升降机'){
                            list[i].icon = require('../../assets/image/visual/warn5.png')
                        }else if(list[i].type=='卸料平台'){
                            list[i].icon = require('../../assets/image/visual/warn1.png')
                        }else if(list[i].type=='高支模'){
                            list[i].icon = require('../../assets/image/visual/warn6.png')
                        }else if(list[i].type=='混凝土'){
                            list[i].icon = require('../../assets/image/visual/warn4.png')
                        }else if(list[i].type=='深基坑'){
                            list[i].icon = require('../../assets/image/visual/warn2.png')
                        }
                        list[i].height = list[i].height && list[i].height!='' && list[i].height!='null'?list[i].height+'':'0'
                        list[i].weight = list[i].weight && list[i].weight!='' && list[i].weight!='null'?list[i].weight+'':'0'
                    }
                    that.hazardList = list
                }
                if(that.pageTimer["timer3"]){
                    window.clearInterval(that.pageTimer["timer3"])
                }
                that.pageTimer["timer3"] = setInterval(that.scroll3,3000) // 预警信息滚动
            })
        },

        //扬尘监测 - 24小时
        getDustLine(){
            var that = this
            myHttp.get24HourStatisByProjectId({
                projectId: this.groupId
            }).then(function(resp) {
                var list = resp.data.data.dustList || []
                var pm2 = [],
                    pm10 = [],
                    noise = [],
                    temperature = []
                for (var i = 0; i < list.length; i++) {
                    pm2.push(list[i].pm2 || 0)
                    pm10.push(list[i].pm10 || 0)
                    noise.push(list[i].noise || 0)
                    temperature.push(list[i].temperature || 0)
                }
                that.setDustLine(pm2, pm10, noise, temperature)
                //先关闭定时器
                if(that.pageTimer["fun6"]){
                    window.clearTimeout(that.pageTimer["fun6"])
                }
                //定时刷新
                that.pageTimer["fun6"] = setTimeout(function(){
                    that.getDustLine()
                },that.timeout)
            })
        },
        //扬尘监测 - PM2.5监测
        getDustPie(){
            var that = this
            myHttp.getPM2ByProjectId({
                projectId: this.groupId
            }).then(function(resp) {
                var data = resp.data.data.pm25
                var all = parseInt(data.cha) + parseInt(data.you) + parseInt(data.liang)
                data.all = all
                that.setDustPie(data)
                //先关闭定时器
                if(that.pageTimer["fun7"]){
                    window.clearTimeout(that.pageTimer["fun7"])
                }
                //定时刷新
                that.pageTimer["fun7"] = setTimeout(function(){
                    that.getDustPie()
                },that.timeout)
            })
        },
        //获取监控列表
        getMonitorList(){
            var that = this
            myHttp.getCameraListBySomething({
                projectId:this.groupId,
                useType:''
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list||[];
                    for(var i=0;i<list.length;i++){
                        list[i].showUrl = '/monitor/view/one.html?serial='+list[i].serial+'&channel='+list[i].channelNo+'&token='+that.ysToken
                    }
                    that.allMonitorList = list
                    that.setMonitorList()
                }
            })
        },
        //监控选择
        monitorSelectionChange(val){
            this.selMonitorList = val
        },
        //设置展示监控
        setMonitorList(){
            var monitor = []
            var list = this.selMonitorList
            var all = this.allMonitorList
            for(var i=0;i<all.length;i++){
                for(var j=0;j<list.length;j++){
                    if(list[j].id == all[i].id){
                        monitor.push(all[i])
                    }
                }
            }
            var that = this
            setTimeout(function(){
                if(monitor.length>6){
                    that.monitorList = []
                    for(var k=0;k<6;k++){
                        that.monitorList.push(monitor[i])
                    }
                }else{
                    that.monitorList = monitor
                }
            },3000)
        },
        //打开监控弹出框
        showMonitorDig(){
            this.monitorVis = true
            var that = this
            setTimeout(function(){
                that.allMonitorList.forEach(row => {
                    for(var i=0;i<that.monitorList.length;i++){
                        if(row.id == that.monitorList[i].id){
                            that.$refs.monitorTable.toggleRowSelection(row,true);
                        }
                    }
                });
            },100)
            
        },
        //取消
        cancleMonitor(){
            this.$refs.monitorTable.clearSelection();
            // this.selMonitorList = JSON.parse(JSON.stringify(this.monitorList))
            this.monitorVis = false
        },
        //保存
        subMonitorCtl(){
            var list = []
            if(this.selMonitorList.length>6){
                list = this.selMonitorList.slice(0,6);
            }else{
                list = this.selMonitorList
            }
            var that = this
            setTimeout(function(){
                that.monitorList = JSON.parse(JSON.stringify(list))
                that.saveModultList() //保存
            },1000)
            this.monitorVis = false
            
        },
        // filterMonitor(id,list){
        //     var result = false
        //     for(var i=0;i<list.length;i++){
        //         if(id == list[i].id){
        //             result = true
        //         }
        //     }
        //     return result
        // },
        /**
         * 获取塔吊列表
         */
        getTowerList(){
            var that = this
            myHttp.getTowerListByPage({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.towerList||[]
                    for(var i=0;i<list.length;i++){
                        list[i].cameraFlag = list[i].camera?true:false
                        if(that.towerIndex==='' && list[i].cameraFlag){
                            that.towerIndex = i
                        }
                    }
                    that.towerList = list
                    if(that.towerIndex!==''){
                        that.towerVideo = '/monitor/view/one.html?serial='+list[that.towerIndex].camera.serial+'&channel='+list[that.towerIndex].camera.channelNo+'&token='+that.ysToken
                    }
                    // var index = 0
                    // if(list.length>0){
                    //     for(var i=0;i<list.length;i++){
                    //         if(list[i].name=='4号塔吊'){
                    //             index = i
                    //         }
                    //     }
                    //     that.getRealInfo(index)
                    // }
                }
            })
        },
        // getRealInfo(index){
        //     var that = this
        //     var id = this.towerList[index].id
        //     this.towerIndex = index
        //     myHttp.getTowerInfoByPage({
        //         id:id,
        //         v:new Date().getTime()
        //     }).then(function(resp){
        //         if(resp.data.code=='200'){
        //             var data = resp.data.data.tower||{}
        //             that.cameraData = data.camera
        //             if(data.camera){
        //                 that.towerLoad = false
        //                 that.towerVideo = '/monitor/view/one.html?serial='+data.camera.serial+'&channel='+data.camera.channelNo+'&token='+that.ysToken
        //             }else{
        //                 if(index<that.towerList.length){
        //                     that.getRealInfo(index+1)
        //                 }
        //             }
        //         }else{
        //             that.towerLoad = false
        //         }
        //     },function(){that.towerLoad = false})
        // },
        //切换塔吊监控
        changeTower(e){
            this.towerVideo = '/monitor/view/one.html?serial='+this.towerList[this.towerIndex].camera.serial+'&channel='+this.towerList[this.towerIndex].camera.channelNo+'&token='+this.ysToken
            
        },

        /**
         * 获取bim
         */
        getBimList(){
            var that = this
            myHttp.selectProProjectBimPage({
                pageNum:1,
                pageSize:1000,
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    if(list.length>0){
                        // that.getUrlByBim(list[0].id)
                        var html = '/data/bimWeb.html?id='+list[0].id
                        that.bimUrl = html
                    }
                }
            })
        },
        // getUrlByBim(id){
        //     var that = this
        //     myHttp.getProProjectBim({
        //         id:id
        //     }).then(function(resp){
        //         if(resp.data.code=='200'){
        //             var data = resp.data.data.proProjectBim
        //             if(data){
        //                 var html = ''
        //             }
        //         }
        //     })
        // },

        /**********图表************************************************************************************************************** */
        //人员动态
        showSysChat(){
            var zz = !this.syn.zz||this.syn.zz == 0?0:this.syn.zz
            var lz = !this.syn.lz||this.syn.lz == 0?0:this.syn.lz
            var wzz = !this.syn.wzz||this.syn.wzz == 0?0:this.syn.wzz
            var option = {
                tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                graphic: {
                    type: 'text',
                    left: 'center',
                    top: 'center',
                    z: 2,
                    style: {
                        text: '累计统计 \n '+this.syn.zs+'人',
                        textAlign: 'center',
                        fill: '#ffffff',
                        width: 30,
                        height: 30,
                        lineWidth:40,
                        fontSize: '100%',
                        fontWeight: 'bold',
                    },
                },
                series: [
                {
                    name: '累计人数',
                    type: 'pie',
                    radius: ['50%', '80%'],
                    hoverAnimation: false,
                    avoidLabelOverlap: false,
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colorList = ['#18B7F8','#FF9F20', '#64EBA8', '#238FFE']
                                return colorList[params.dataIndex]
                            },
                        },
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'outside',
                            formatter: '{b}\n{c}',
                            textStyle: {
                                fontSize: '0',
                                fontWeight: 'bold',
                            },
                            emphasis: {
                                show: true,
                            },
                        },
                    },
                    labelLine: {
                        show: false,
                        length:8 ,
                        length2:8,
                    },
                    data: [
                        { value: zz, name: '在职' },
                        { value: lz, name: '离职' },
                        { value: wzz, name: '未分配' },
                    ],
                },
                ],
            }
            if(document.getElementById('myChart1')){
                var myChart1 = this.$echarts.init(document.getElementById('myChart1'))
                myChart1.setOption(option);
            }
        },
        //安全教育（教育）
        showEdu(data){
            data = data?data:{
                allNum: 0,
                educationNum: 0
            }
            data.eduOther = parseInt(data.allNum) - parseInt(data.educationNum)
            data.educationNum = data.educationNum==0?0.001:parseInt(data.educationNum)
            data.eduOther = data.eduOther==0?0.001:parseInt(data.eduOther)
            if(!document.getElementById('eduChart'))return;
            Highcharts.chart('eduChart',{
                chart: {
                    type: 'pie',
                    backgroundColor:'transparent',
                    options3d: {
                        enabled: true,
                        alpha: 45,
                        beta: 0
                    }
                },
                colors:[
                    {
                        radialGradient: {
                            cx: 0.5,
                            cy: 0.5,
                            r: 0.7
                        },
                        stops: [
                            [0, 'rgba(155, 251, 239, 0)'],
                            [1, 'rgba(155, 251, 239, 1)']
                        ]
                    }, {
                        radialGradient: {
                            cx: 0.5,
                            cy: 0.3,
                            r: 0.7
                        },
                        stops: [
                            [0, '#B062F9'],
                            [1, '#8400FF']
                        ]
                    }
                ],
                title: {
                    text: ''
                },
                tooltip: {
                    pointFormat: '{point.name}: <b>({point.percentage:.1f}%)</b>',
                    headerFormat:''
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        innerSize: 80,
                        depth: 80,
                        background:'#000',
                        dataLabels: {
                            enabled: true,
                            format: '{point.name} <br/> {point.percentage:.1f}%',
                        }
                    }
                },
                series: [{
                    type: 'pie',
                    name: '安全教育',
                    size:'80%',
                    center:['40%','35%'],
                    data: [
                        ['已受教育',   data.educationNum],
                        ['未受教育',   data.eduOther],
                    ],
                    dataLabels:{
                        formatter: function () {
                            return this.point.name;
                        },
                        distance: 1,
                        style:{
                            color:'#ffffff'
                        }
                    },
                }]
            })
        },
        //安全教育（考试）
        showExam(data){
            data = data?data:{
                allNum: 0,
                paperNum: 0
            }
            data.other = parseInt(data.allNum) - parseInt(data.paperNum)
            data.paperNum = data.paperNum==0?0.00001:parseInt(data.paperNum)
            data.other = data.other==0?0.00001:parseInt(data.other)
            if(!document.getElementById('examChart'))return;
            Highcharts.chart('examChart',{
                chart: {
                    type: 'pie',
                    backgroundColor:'transparent',
                    options3d: {
                        enabled: true,
                        alpha: 45,
                        beta: 0
                    }
                },
                colors:[
                    {
                        radialGradient: {
                            cx: 0.5,
                            cy: 0.5,
                            r: 0.7
                        },
                        stops: [
                            [0, 'rgba(0, 138, 255, 0)'],
                            [1, 'rgba(0, 138, 255, 1)']
                        ]
                    }, {
                        radialGradient: {
                            cx: 0.5,
                            cy: 0.3,
                            r: 0.7
                        },
                        stops: [
                            [0, '#FF8A00'],
                            [1, '#FFCA3D']
                        ]
                    }
                ],
                title: {
                    text: ''
                },
                tooltip: {
                    pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>',
                    headerFormat:''
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        innerSize: 80,
                        depth: 80,
                        background:'#000',
                        dataLabels: {
                            enabled: true,
                            format: '{point.name} <br/> {point.percentage:.1f}%',
                        }
                    }
                },
                series: [{
                    type: 'pie',
                    name: '入职考试',
                    size:'80%',
                    center:['50%','35%'],
                    data: [
                        ['已入职考试',   data.paperNum],
                        ['未入职考试',   data.other],
                    ],
                    dataLabels:{
                        formatter: function () {
                            return this.point.name;
                        },
                        distance: 1,
                        style:{
                            color:'#ffffff'
                        }
                    },
                }]
            })
        },
        //预警信息
        showWarn(data){
            data = data?data:{
                concreteCount: 0,
                count: '0',
                deepCount: 0,
                environmentalCount: 0,
                highDieCount: 0,
                liftCount: 0,
                smartSceneCount: 0,
                towerCount: 0,
                unloadingPlatformCount: 0,
            }
            var type = 'area'
            for(var item in data){
                if(data[item]==0){
                    type = ''
                }
            }
            //
            var option = {
                title: {
                    text: '预警总量',
                    subtext: data.count+'',
                    left: 'center',
                    top:'center',
                    textStyle:{
                        fontSize:'16',
                        fontWeight:'bold',
                        color:'#ffffff',
                        width:'10%',
                    },
                    subtextStyle:{
                        fontSize:'16',
                        color:'#ffffff',
                        width:1000,
                        align:'center'
                    },
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)',
                    
                },
                legend: {
                    show:false,
                    orient:'vertical',
                    align:'left',
                    left: '10',
                    top: 'bottom',
                    data: ['塔吊', '卸料平台', '升降机', '深基坑', '高支模', '大体积混凝土'],
                    textStyle:{
                        color:'#fff'
                    }
                },
                series: [
                    {
                        name: '预警统计',
                        type: 'pie',
                        radius: [40, 70],
                        center: ['50%', '50%'],
                        roseType: type,
                        label: {
                            show: false
                        },
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList = ['#FDD100','#3FECFF', '#007CFF', '#ED5400','#7351E3','#FF4873','#1FB5A5']
                                    return colorList[params.dataIndex]
                                },
                            },
                        },
                        data: [
                            {value: data.towerCount, name: '塔吊'},
                            {value: data.unloadingPlatformCount, name: '卸料平台'},
                            {value: data.liftCount, name: '升降机'},
                            {value: data.deepCount, name: '深基坑'},
                            {value: data.highDieCount, name: '高支模'},
                            {value: data.concreteCount, name: '大体积混凝土'}
                        ]
                    }
                ]
            };
            if(document.getElementById('warnChart')){
                var myChart1 = this.$echarts.init(document.getElementById('warnChart'))
                myChart1.setOption(option);
            }
        },
        //累计统计健康码
        setAllAn(){
            // var data = this.ageBar
            if(!document.getElementById('ankang1'))return;
            
            var green1 = this.anKang.green1==0?0.0001:parseInt(this.anKang.green1)
            var yellow1 = this.anKang.yellow1 == 0?0.0001:parseInt(this.anKang.yellow1)
            var red1 = this.anKang.red1 ==0?0.0001:parseInt(this.anKang.red1)
            Highcharts.chart('ankang1', {
                chart: {
                    type: 'column',
                    backgroundColor: 'rgba(0,0,0,0)',
                    marginBottom: 10,
                    marginTop:10
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ''
                },
                colors:['#0CCF93','F8DA2A','#FB2121'],
                xAxis: {
                    type: 'category',
                    title: {
                        align:'high',
                        style:{
                            fontSize:'10'
                        }
                    },
                    lineColor:'#3A85E0',
                    labels:{
                        style:{
                            color:'#000000'
                        }
                    },
                },
                yAxis: {
                    title: {
                        text: '',
                        align:'high',
                    },
                    minorGridLineColor:'#000000',
                    minorTickColor:'#3A85E0',
                    gridLineColor:'#000000',
                    lineColor:'#3A85E0',
                    lineWidth:1,
                    labels:{
                        style:{
                            color:'#ffffff'
                        }
                    },
                    maxPadding: 0.2,
                    tickInterval:10
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    pointFormat: '{point.name}: <b>{point.y:.0f} 人</b>',
                    headerFormat:'{series[0].center[1]}<br/>'
                },
                series: [{
                    name: '',
                    borderRadius:'0',
                    maxPointWidth:15,
                    data: [
                        {'color':'#0CCF93','y':green1,'name':'正常绿码'},
                        {'color':'#F8DA2A','y':yellow1,'name':'异常黄码'},
                        {'color':'#FB2121','y':red1,'name':'异常红码'},
                    ],
                }]
            });
        },
        //本月统计健康码
        setMonthAn(){
            document.getElementById('ankang2').innerHTML = ''
            if(!document.getElementById('ankang2'))return;
            var green2 = this.anKang.green2 == 0?0.0001:parseInt(this.anKang.green2)
            var yellow2 = this.anKang.yellow2 == 0?0.0001:parseInt(this.anKang.yellow2)
            var red2 = this.anKang.red2==0?0.0001:parseInt(this.anKang.red2)
            Highcharts.chart('ankang2', {
                chart: {
                    type: 'column',
                    backgroundColor: 'rgba(0,0,0,0)',
                    marginBottom: 10,
                    marginTop:10
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ''
                },
                colors:['#0CCF93','#ffffff'],
                xAxis: {
                    type: 'category',
                    title: {
                        align:'high',
                        style:{
                            fontSize:'10'
                        }
                    },
                    lineColor:'#3A85E0',
                    labels:{
                        style:{
                            color:'#000000'
                        }
                    },
                },
                yAxis: {
                    // min: 0,
                    title: {
                        text: '',
                        align:'high',
                    },
                    minorGridLineColor:'#000000',
                    minorTickColor:'#3A85E0',
                    gridLineColor:'#000000',
                    lineColor:'#3A85E0',
                    lineWidth:1,
                    labels:{
                        style:{
                            color:'#ffffff'
                        }
                    },
                    maxPadding: 0.2,
                    tickInterval:10
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    pointFormat: '{point.name}: <b>{point.y:.0f} 人</b>',
                    headerFormat:'{series[0].center[1]}<br/>'
                },
                series: [{
                    name: '',
                    borderRadius:'0',
                    maxPointWidth:15,
                    data: [
                        {'color':'#0CCF93','y':green2,'name':'正常绿码'},
                        {'color':'#F8DA2A','y':yellow2,'name':'异常黄码'},
                        {'color':'#FB2121','y':red2,'name':'异常红码'},
                    ],
                }]
            });
        },
        //实名制
        setRealName(data){
            var val = 0
            var bilv = 0
            if(data){
                bilv = data.allWorkPerson==0?0:(parseInt(data.attendancePerson)/parseInt(data.allWorkPerson)).toFixed(2)
                val = bilv*100
            }
            var option = {
                tooltip: {
                    formatter: '{a} <br/>{b} : {c}%'
                },
                series: [
                    {
                        name: '出勤率',
                        type: 'gauge',
                        min: 0,
                        max: 100,
                        splitNumber: 2,
                        radius: '90%',
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                //color: [[0.09, 'lime'], [0.82, '#1e90ff'], [1, '#ff4500']],
                                width: 20,
                                shadowColor: '#fff', //默认透明
                                shadowBlur: 1,
                                color:[
                                    [bilv, new this.$echarts.graphic.LinearGradient(
                                        0, 1, 0, 0,
                                        [{
                                            offset: 0,
                                            color: '#2C3B59'
                                        }, {
                                            offset: 1,
                                            color: '#43A195'
                                        }]
                                    )],
                                    [bilv, '#43A195'],
                                    [1, '#2C3B59']
                                ]
                            }
                        },
                        axisLabel: {            // 坐标轴小标记
                            color: '#34ECFF',
                            shadowColor: '#fff', //默认透明
                            formatter: function (v){
                                switch (v + '') {
                                    case '0': return '0%';
                                    case '50': return '50%';
                                    case '100': return '100%';
                                }
                            }
                        },
                        axisTick: {            // 坐标轴小标记
                            length: 0,        // 属性length控制线长
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: 'auto',
                                shadowColor: '#fff', //默认透明
                                shadowBlur: 5
                            }
                        },
                        splitLine: {           // 分隔线
                            length: 8,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                width: 3,
                                color: '#fff',
                                shadowColor: '#fff', //默认透明
                                shadowBlur: 10
                            }
                        },
                        pointer: {         
                            width:'6'
                        },
                        title: {
                            show:false,
                            textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                                fontWeight: 'bolder',
                                fontSize: 20,
                                fontStyle: 'italic',
                                color: '#fff',
                                shadowColor: '#fff', //默认透明
                                shadowBlur: 10
                            }
                        },
                        detail: {
                            offsetCenter: ['0%', '85%'],       // x, y，单位px
                            textStyle: {
                                color: '#34ECFF',
                                fontSize:16
                            },
                            formatter:function (value) {
                                return '出勤率 \n\n'+value+'%';
                            },
                        },
                        data: [{value: val, name: '出勤率',itemStyle:{color:'#FFFA69'}}]
                    }
                ]
            };
            if(document.getElementById('realChart')){
                var myChart1 = this.$echarts.init(document.getElementById('realChart'))
                myChart1.setOption(option);
            }
        },

        //质量安全
        setSafeChat(){
            var data1 = !this.qsChar.projectPendingCount || this.qsChar.projectPendingCount==0?0.0001:this.qsChar.projectPendingCount
            var data2 = !this.qsChar.projectProcessedCount || this.qsChar.projectProcessedCount==0?0.0001:this.qsChar.projectProcessedCount
            //var data3 = !this.qsChar.projectNoProblemCount || this.qsChar.projectNoProblemCount==0?0.0001:this.qsChar.projectNoProblemCount
            if(!document.getElementById('safe1'))return;
            Highcharts.chart('safe1',{
                chart: {
                    type: 'pie',
                    backgroundColor:'transparent',
                    options3d: {
                        enabled: true,
                        alpha: 45,
                        beta: 0
                    }
                },
                colors:[{
                    radialGradient: {
                        cx: 0.5,
                        cy: 0.3,
                        r: 0.7
                    },
                    stops: [
                        [0, '#0CF6F4'],
                        [1, '#44CAEA']
                    ]
                }, {
                    radialGradient: {
                        cx: 0.5,
                        cy: 0.3,
                        r: 0.7
                    },
                    stops: [
                        [0, '#675FE3'],
                        [1, '#5889DA']
                    ]
                }],
                title: {
                    text: ''
                },
                tooltip: {
                    pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>',
                    headerFormat:''
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        depth: 10,
                        dataLabels: {
                            enabled: true,
                            format: '{point.percentage:.1f}%',
                            style: {
                                color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                            },
                            connectorColor: 'silver'
                        }
                    }
                },
                series: [{
                    type: 'pie',
                    name: '项目检查',
                    size:'120%',
                    center:['50%','50%'],
                    color:[],
                    data: [
                        ['已处理',   data2],
                        ['未处理',   data1],
                    ],
                    dataLabels:{
                        formatter: function () {
                            return this.point.name;
                        },
                        distance: -30,

                    },
                }]
            })
            //公司
            // var data4 = !this.qsChar.entPendingCount || this.qsChar.entPendingCount==0?0.0001:this.qsChar.entPendingCount
            // var data5 = !this.qsChar.entProcessedCount || this.qsChar.entProcessedCount==0?0.0001:this.qsChar.entProcessedCount
            // Highcharts.getOptions().colors = Highcharts.map(Highcharts.getOptions().colors, function (color) {
            //     return {
            //         radialGradient: { cx: 0.5, cy: 0.3, r: 0.7 },
            //         stops: [
            //             [0, color],
            //             [1, Highcharts.Color(color).brighten(-0.3).get('rgb')] // darken
            //         ]
            //     };
            // });
            // if(!document.getElementById('safe2'))return;
            // Highcharts.chart('safe2',{
            //     chart: {
            //         type: 'pie',
            //         backgroundColor:'transparent',
            //         options3d: {
            //             enabled: true,
            //             alpha: 45,
            //             beta: 0
            //         }
            //     },
            //     colors:[
            //         {
            //             radialGradient: {
            //                 cx: 0.5,
            //                 cy: 0.3,
            //                 r: 0.7
            //             },
            //             stops: [
            //                 [0, '#37CCFF'],
            //                 [1, '#37CCFF']
            //             ]
            //         }, {
            //             radialGradient: {
            //                 cx: 0.5,
            //                 cy: 0.3,
            //                 r: 0.7
            //             },
            //             stops: [
            //                 [0, '#B67C1D'],
            //                 [1, '#C5B83B']
            //             ]
            //         }
            //     ],
            //     title: {
            //         text: ''
            //     },
            //     tooltip: {
            //         pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>',
            //         headerFormat:''
            //     },
            //     plotOptions: {
            //         pie: {
            //             allowPointSelect: true,
            //             cursor: 'pointer',
            //             depth: 10,
            //             dataLabels: {
            //                 enabled: true,
            //                 format: '{point.percentage:.1f}%',
            //                 style: {
            //                     color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
            //                 },
            //                 connectorColor: 'silver'
            //             }
            //         }
            //     },
            //     series: [{
            //         type: 'pie',
            //         name: '公司检查',
            //         size:'100%',
            //         center:['50%','50%'],
            //         data: [
            //             ['已处理',data5],
            //             ['未处理',data4],
            //         ],
            //         dataLabels:{
            //             formatter: function () {
            //                 return this.point.name;
            //             },
            //             distance: -30,
            //         },
            //     }]
            // })
            
        },
        //扬尘监测（项目）
        setDustLine(pm2,pm10,noise,temperature){
            pm2 = pm2.length>0?pm2:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            pm10 = pm10.length>0?pm10:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            noise = noise.length>0?noise:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            temperature = temperature.length>0?temperature:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            var option = {
                title: {
                    text: ''
                },
                legend: {
                    data: ['PM2.5', 'PM10', '噪音(dB)', '温度(℃)'],
                    textStyle:{
                        color:'#fff',
                        fontSize:'100%'
                    },
                    // itemWidth :5,
                    // itemHeight:5, 
                    right:'5%',
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top:'20%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: ['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
                        nameTextStyle:{
                            color:'#fff'
                        },
                        axisLine:{
                            lineStyle:{
                                color:'#fff',
                            }
                        },
                    }
                ],
                color: ['#29AC5D', '#FF854E', '#892FD5', '#5473E8'],
                yAxis: [
                    {
                        type: 'value',
                        axisLine:{
                            lineStyle:{
                                color:'#fff'
                            }
                        },
                        name: '',
                        splitLine:{
                            show:false
                        }
                    }
                ],
                series: [
                    {
                        name: 'PM2.5',
                        type: 'line',
                        smooth: true,
                        areaStyle: {},
                        data: pm2
                    },
                    {
                        name: 'PM10',
                        type: 'line',
                        smooth: true,
                        areaStyle: {},
                        data: pm10
                    },
                    {
                        name: '噪音(dB)',
                        type: 'line',
                        smooth: true,
                        areaStyle: {},
                        data: noise
                    },
                    {
                        name: '温度(℃)',
                        type: 'line',
                        smooth: true,
                        areaStyle: {},
                        data: temperature
                    }
                ]
            }
            if(document.getElementById('dust1')){
                var dust1 = this.$echarts.init(document.getElementById('dust1'))
                dust1.setOption(option)
            }
        },
        //扬尘监测（项目）
        setDustPie(data){
            data = data?data:{all:0,you:0,liang:0,cha:0}
            var option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                graphic: {
                    type: 'text',
                    left: 'center',
                    top: 'center',
                    z: 2,
                    style: {
                        text: data.all+'天',
                        x: 100,
                        y: 100,
                        textAlign: 'center',
                        fill: '#ffffff',
                        height: 30,
                        fontSize: '100%',
                        fontWeight: 'bold'
                    }
                },
                legend: {
                    orient: 'horizontal',
                    x: 'center',
                    bottom:'10',
                    data: ['优', '良', '轻度'],
                    textStyle:{
                        color:'#fff',
                        fontSize:'100%',
                    },
                },
                series: [
                {
                    name: '环境监测',
                    type: 'pie',
                    radius: ['50%', '65%'],
                    center:['50%','50%'],
                    hoverAnimation: false,
                    itemStyle: {
                    normal: {
                        color: function(params) {
                        var colorList = ['#4C63F2', '#3FECFF', '#7351E3']
                        return colorList[params.dataIndex]
                        }
                    }
                    },
                    avoidLabelOverlap: false,
                    label: {
                        normal: {
                            show: false
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: [
                        { value: data.you, name: '优' },
                        { value: data.liang, name: '良' },
                        { value: data.cha, name: '轻度' }
                    ]
                }
                ]
            }
            if(document.getElementById('dust2')){
                var page = this.$echarts.init(document.getElementById('dust2'))
                page.setOption(option)
            }
        },

        //
        showDialogFun(){
            this.ctrlVis = true
            this.modularList = JSON.parse(JSON.stringify(this.allList))
        },
        //点击确认
        refreshCtl(){
            var listData = this.modularList
            this.modularList = []
            this.allList = JSON.parse(JSON.stringify(listData))
            for(var i=0;i<this.list0.length;i++){
                for(var m=0;m<listData.length;m++){
                    if(this.list0[i].index==listData[m].index){
                        this.list0[i] = listData[m]
                    }
                }
                // this.list0[i].margin = listData[i].margin==''?0:listData[i].margin
                // this.list0[i].border = listData[i].border
                // this.list0[i].show = listData[i].show
            }
            var len1 = this.list1.length
            for(var j=0;j<len1;j++){
                for(var k=0;k<listData.length;k++){
                    if(this.list1[j].index==listData[k].index){
                        this.list1[j] = listData[k]
                    }
                }
            }
            // var len2 = this.listMid.length
            // for(var j=0;j<len2;j++){
            //     for(var k=0;k<listData.length;k++){
            //         if(this.listMid[j].index==listData[k].index){
            //             this.listMid[j] = listData[k]
            //         }
            //     }
            //     if(this.listMid[j].index=='50'){
            //         this.towerVideoFlag = this.listMid[j].show?true:false
            //     }
            // }
            // //获取塔吊监控
            // if(this.towerVideoFlag){
            //     this.getTowerList()
            // }else{
            //     this.getQsData() //质量安全
            // }
            this.ctrlVis = false
            //保存修改
            this.saveModultList()
        },

        /**监听模块移动 */
        log(evt){
            if(this.list0.length==0||this.list1.length==0)return;
            var list = JSON.parse(JSON.stringify(this.list0))
            var list1 = JSON.parse(JSON.stringify(this.list1))
            this.list0  = []
            this.list1  = []
            console.log(list,list1)
            var that = this
            setTimeout(function(){
                that.list0 = list
                that.list1 = list1
                that.saveModultList() //保存模块改变
            },0)
            
        },
        //根据选择确定true和false
        equipFilter(item){
            var list = this.tableEquip
            var result = false
            for(var i=0;i<list.length;i++){
                if(item.id == list[i].id){
                    result = true
                }
            }
            return result
        },
        /**
         * 监听设备编辑
         */
        handleSelectionChange(val){
            this.tableEquip = val
        },
        //保存设备
        saveEquip(){
            var num = 0
            for(var i=0;i<this.equipStatusList.length;i++){
                this.equipStatusList[i].show = this.equipFilter(this.equipStatusList[i])
                if(this.equipStatusList[i].show){
                    num += 1
                }
            }
            this.equipWidth = 86/num
            this.saveModultList()
        },
        /**
         * 保存模块
         */
        saveModultList(){
            var that = this
            var data = []
            data.push(this.list0)
            data.push(this.list1)
            data.push(this.equipStatusList)
            data.push(this.monitorList)
            if(this.moduleExeit){//修改
                myHttp.updateHomePage({
                    groupId:this.groupId,
                    numerical:JSON.stringify(data),
                    type:'4'
                }).then(function(resp){
                    if(resp.data.code=='200'){
                        // that.getAnKang()
                        that.getSynData() //获取人员动态（位置改变后重新渲染）
                        that.getWarnInfo() //预警信息（位置改变后重新渲染）
                        that.getEduFun()  //安全教育（位置改变后重新渲染）
                        that.getDustLine() //扬尘设备-24小时（位置改变后重新渲染）
                        that.getDustPie()  //扬尘设备 - PM2.5（位置改变后重新渲染）
                        that.getQsData()
                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){
                    that.$message.error('服务器繁忙，请稍后再试');
                })
            }else{  //添加
                myHttp.postHomePage({
                    groupId:this.groupId,
                    numerical:JSON.stringify(data),
                    type:'4'
                }).then(function(resp){
                    if(resp.data.code=='200'){
                        that.getSynData() //获取人员动态（位置改变后重新渲染）
                        that.getWarnInfo() //预警信息（位置改变后重新渲染）
                        that.getEduFun()  //安全教育（位置改变后重新渲染）
                        that.getDustLine() //扬尘设备-24小时（位置改变后重新渲染）
                        that.getDustPie()  //扬尘设备 - PM2.5（位置改变后重新渲染）
                        that.getQsData()
                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){
                    that.$message.error('服务器繁忙，请稍后再试');
                })
            }
        },

        /*************滚动*************************************************************************** */
        //预警信息
        scroll1(){
            if(this.warnList.length>2){
                var that = this
                this.animate1=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
                setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                        this.warnList.push(this.warnList[0]);  // 将数组的第一个元素添加到数组的
                        this.warnList.shift();               //删除数组的第一个元素 attendTeam   
                        this.animate1 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
                },2500)
            }else{
                window.clearInterval(this.pageTimer["timer1"])
            }
        },
        //人员实名制
        scroll2(){
            if(this.realList.length>3){
                var that = this
                this.animate2=true;
                setTimeout(()=>{
                        this.realList.push(this.realList[0]);
                        this.realList.shift();
                        this.animate2 = false;
                },2500)
            }else{
                window.clearInterval(this.pageTimer["timer2"])
            }
        },
        //大危险源
        scroll3(){
            if(this.hazardList.length>4){
                var that = this
                this.animate3=true;
                setTimeout(()=>{
                        this.hazardList.push(this.hazardList[0]);
                        this.hazardList.push(this.hazardList[1]);
                        this.hazardList.shift();
                        this.hazardList.shift();
                        this.animate3 = false;
                },2500)
            }else{
                window.clearInterval(this.pageTimer["timer3"])
            }
        },

        //返回
        goBackFun(){
            this.$router.go(-1)
        },
    },
    destroyed(){
        for(var each in this.pageTimer){
            window.clearTimeout(this.pageTimer[each]);
            window.clearInterval(this.pageTimer[each]);
        }
        
    },
    
}
</script>

<style scoped>
    *{
        color: #fff;
        font-size: 28rem;
    }
    .big-box{
        width: 5760rem;
        height: 2160rem;
        position: relative;
        padding: 25rem 160rem;;
        background: url('../../assets/image/visual/screen.jpg');
        background-size: 100% 100%;
        display: flex;
        justify-content: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;
        overflow: hidden;
    }
    /* left0 */
    .list-group-box1{
        width: 1400rem;
        height: 1960rem;
        position: relative;
        padding: 0;
        /* margin-left: 30rem; */
    }
    .item-title{
        width: 68.75%;
        height: 60rem;
        min-height: 50rem;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        margin: 0 auto;
        background: url('../../assets/image/visual/txt1.png');
        color: #34ECFF;
        font-size: 32rem;
    }
    .borderCss{
        background: url('../../assets/image/visual/viaul-bg5.png');
        background-size:100% 100%; 
    }
    .crile{
        width: 16rem;
        height: 16rem;
        position: relative;
        border-radius: 50%;
        background: #34ECFF;
        margin-right: 10rem;
        display: inline-block;
    }

    /** 设备运行 **/
    .item-head-p{
        width: 100%;
        height: 60rem;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .item-head-p span{
        width: 14%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }
    .item-head-p span.b-line,.device-item .b-line{
        border-bottom: 2rem solid rgb(112 197 255 / 0.2);
    }
    .item1-con{
        width: 100%;
        /* height: 25vh; */
        position: relative;
        padding: 0 30rem;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
    }
    .device-item{
        width: 100%;
        height: 70rem;
        position: relative;
        display: flex;
    }
    .device-item p,.device-item1 p{
        width: 14%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }
    .device-item1{
        width: 100%;
        height: 80rem;
        position: relative;
        display: flex;
    }
    .item-span{
        position: absolute;
        width: 100%;
        height: 100%;
        left: -1rem;
        top: 2rem;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }

    /* 监控************** */
    .monitorbox-item{
        width:33%;
        height: 50%;
        position: relative;
        /* padding: 0 5rem 10rem; */
        padding: 0;
    }
    .item-monitor{
        width: 100%;
        /* height: calc( 100% - 60rem ); */
        height: 100%;
        position: relative;
        /* background: #fff; */
    }
    .item-info{
        width: 100%;
        height: 50rem;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: space-around;
        /* background: #fff; */
    }
    .item-info .name{
        flex:1;
        text-align: center;
        
    }

    .anim1{
        transition: all 2s;
        margin-top: -160rem;
    }
    .anim2{
        transition: all 3s;
        margin-top: -185rem;
    }
    .anim3{
        transition: all 2s;
        margin-top: -150rem;
    }
    
</style>

<style>
    @import '../../assets/css/common.css';
    .big-box *{
        color: #fff;
        font-size: 28rem;
    }
    .big-box .el-progress-bar__innerText{
        text-shadow: 0 0 1px currentColor,-1px -1px 1px #000,0 -1px 1px #000,1px -1px 1px #000,1px 0 1px #000,1px 1px 1px #000,0 1px 1px #000,-1px 1px 1px #000,-1px 0 1px #000;
    }
    .bigVitalDia{
        /* background: rgb(0 0 0 / 0.5); */
        background: rgba(11, 37, 104, 0.45);
        border: 2rem solid #707070;
    }
    .bigVitalDia *{
        color:#34ECFF;
    }
    .bigVitalDia .el-input__inner{
        background: transparent;
        border: 1rem solid #34ECFF;
        height: 60rem;
    }
    .bigVitalDia .el-button{
        border: 1rem solid #34ECFF;
        background: #0B2568;
        color: #fff;
    }
    .popClass.el-popover{
        background: rgba(11, 37, 104, 0.45);
        border: 2rem solid #707070;
    }
    .popClass *{
        color: #000;
    }
    .tower-video-sel .el-input__inner{
        height: 60rem;
        /* background: radial-gradient(#0a2c75, transparent); */
        background: transparent;
        border: 0;
        text-align: right;
    }
    .tower-video-sel .el-select .el-input .el-select__caret{
        line-height: 40rem;
    }
    .video-towers{
        /* background: transparent; */
        border: 1rem solid #34ECFF;
        background: #0B2568;
    }
    .video-towers .el-select-dropdown__item.hover, .video-towers .el-select-dropdown__item:hover{
        color: #0b2568;
    }
    .bigVitalDia .el-table td,.bigVitalDia .el-table th.is-leaf{
        background: rgba(11, 37, 104, 0.45);
        border:0;
    }
    .bigVitalDia .el-table--enable-row-hover .el-table__body tr:hover>td{
        background: rgba(11, 37, 104, 0.6);
    }
    .bigVitalDia .el-table th,.bigVitalDia .el-table tr,.el-table, .el-table__expanded-cell{
        background: transparent;
    }
    html{
        font-size:0.5px;
    }
</style>